import Quill from 'quill'

import 'quill/dist/quill.bubble.css'
import 'quill/dist/quill.core.css'

export default defineNuxtPlugin(() => {

  // --- public ---
  const createQuill = (container: HTMLElement, options: any): Quill => {
    return new Quill(container, options)
  }

  return {
    provide: {
      createQuill,
    },
  }

})
